module.exports = __webpack_public_path__ + "static/media/certif-icon.52a46586.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/certif-icon.svg
// module id = 106
// module chunks = 0